const queues = {
  title: "Queues",
  id: "ID",
  queue: "Queue",
  payload: "Payload",
  attempts: "Attempts",
  reserved_at: "Reserved At",
  available_at: "Available At",
  created_at: "Date Created",
}
export default queues
